import { DESCENDER_RATIO_PER_FONT_SIZE } from '@app/components/TextField/constants';
import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

export function getTextBaseFieldMinimumSize(fontSize: number, scale: number) {
  const fontPixelSize: number = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);
  // 'g', 'j', 'q' 등과 같이 폰트 높이 아래로 튀어 나오는 영역을 보정하기 위한 값
  const descenderHeight = fontPixelSize * DESCENDER_RATIO_PER_FONT_SIZE;
  return createAbsoluteSize({
    width: fontPixelSize,
    height: fontPixelSize + descenderHeight,
  });
}
